module.exports = __webpack_public_path__ + "static/media/img-evaluator.b2fb1a15.png";